import { useEffect } from 'react';

const useClickAwayListener = (
  ref,
  handler,
  shouldHandleClickAwayManually = false
) => {
  useEffect(() => {
    if (shouldHandleClickAwayManually) return;

    const listener = (event) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        ref.current === event.target
      ) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, shouldHandleClickAwayManually]);
};

export default useClickAwayListener;
